import { render, staticRenderFns } from "./DetailCompanyPage.vue?vue&type=template&id=3d2878e4&scoped=true&"
import script from "./DetailCompanyPage.vue?vue&type=script&lang=js&"
export * from "./DetailCompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailCompanyPage.vue?vue&type=style&index=0&id=3d2878e4&scoped=true&lang=css&"
import style1 from "./DetailCompanyPage.vue?vue&type=style&index=1&id=3d2878e4&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2878e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2878e4')) {
      api.createRecord('3d2878e4', component.options)
    } else {
      api.reload('3d2878e4', component.options)
    }
    module.hot.accept("./DetailCompanyPage.vue?vue&type=template&id=3d2878e4&scoped=true&", function () {
      api.rerender('3d2878e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/DetailCompanyPage.vue"
export default component.exports